import React, { FC, ReactElement } from 'react'
import styled, { useTheme } from 'styled-components'
import { device } from '../breakpoints'

interface Props {
  title: string
  lead: string
  keywords: string
}

const Header: FC<Props> = ({ keywords, title, lead }): ReactElement => {
  const theme = useTheme()

  return (
    <Container>
      {/* <Hero /> */}
      <ImageContainer
        style={{
          backgroundImage: `url(${require(theme.colorMode === 'dark'
            ? theme.tenant === '24heures' ? './cover-vqh-dark.png' : './cover-tdg-dark.png'
            : theme.tenant === '24heures' ? './cover-vqh.png' : './cover-tdg.png')})`,
        }}
      >
        {/* <img src={require("./cover-sketch.png")} style={{height: "100%", maxWidth: "1200px", margin: "auto"}} /> */}
      </ImageContainer>
      <TextContainer>
        <TextWidth>
          <TitleContainer>
            <Sup>{keywords}</Sup>
            <Title>{title}</Title>
          </TitleContainer>
          <Text>{lead}</Text>
          <Authors>Mathieu Rudaz</Authors>
          <Date>
            <>Mis à jour le 17 octobre 2023</>
          </Date>
        </TextWidth>
      </TextContainer>
    </Container>
  )
}

const TextContainer = styled.div``

const TextWidth = styled.div`
  max-width: 800px;
  margin: 0 auto;
  color: var(--text-color);

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 0 30px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0;
  }
`

const Container = styled.div`
  position: relative;
  margin-bottom: 10rem;
`

const TitleContainer = styled.h2`
  margin-top: 0;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 1.2rem;
    font-size: 2em;
    line-height: 4rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2rem;
    font-size: 3em;
    line-height: 1;
  }
`

const Title = styled.span`
  font-family: var(--font-serif);
  font-weight: 600;
  display: block;
  line-height: 1.2;
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 40vh;
  overflow: hidden;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    background-size: 100% auto;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    background-size: auto 100%;
  }
`

const Text = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.8rem;
    line-height: 2.7rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 2rem;
    line-height: 2.9rem;
  }
`

const Sup = styled.span`
  display: inline-block;
  min-width: 85%;
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 2rem;
  color: rgb(${({ theme }) => theme.colorMain});

  &:before {
    display: inline-block;
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: rgb(
      ${({ theme }) =>
        theme.colorMode === 'dark' ? theme.textColorInverted : '255,255,255'}
    );
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    background-color: rgb(${({ theme }) => theme.colorMain});
    content: 'Abo';
  }
`

const Authors = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.3rem;
  line-height: 1.2;
  margin-bottom: 0.65rem;
  font-weight: bold;
`

const Date = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  opacity: 0.5;
  line-height: 1.2;
`

export default Header
